import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Walnuts = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-yellow-50 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl font-bold text-yellow-700 mb-4">Premium Walnuts</h1>
                <p className="text-lg text-gray-700 max-w-2xl mx-auto">
                    Rich in nutrients and flavor! Discover our premium quality walnuts sourced from trusted farms.
                </p>
            </section>

            {/* Product Details */}
            <section className="max-w-5xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10 items-center">
                <img
                    src="https://source.unsplash.com/600x400/?walnuts"
                    alt="Walnuts"
                    className="rounded-lg shadow-lg"
                    data-aos="zoom-in"
                />
                <div data-aos="fade-left">
                    <h2 className="text-2xl font-bold text-yellow-700 mb-4">Why Choose Our Walnuts?</h2>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700">
                        <li>Excellent source of Omega-3 and antioxidants</li>
                        <li>Freshly harvested and hygienically packed</li>
                        <li>Great for baking, snacking, and health supplements</li>
                        <li>Available in bulk and customized packaging</li>
                    </ul>
                    <div className="mt-6">
                        <h3 className="font-semibold text-lg mb-2">Specifications:</h3>
                        <p className="text-sm text-gray-600">
                            Origin: Kashmir/California<br />
                            Type: In-Shell / Kernel / Organic<br />
                            Packaging: 250g | 500g | 1kg | Bulk Packs<br />
                            Shelf Life: 12 months
                        </p>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Walnuts;
